var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, } from 'react';
import styled from '@emotion/styled';
import { space, width, height, alignItems, themeGet, display, } from 'styled-system';
import { useLocalization } from '../../providers/LocaleProvider';
import { textDecoration, flexShrink, } from '../../theme/system-utilities';
import Icon from '../Icon';
import { ButtonBase, SPINNER_SIZE } from './Base';
import { ButtonPrimary } from './Primary';
import { ButtonSecondary } from './Secondary';
import { ButtonBlack } from './Black';
import { ButtonGreen } from './Green';
import Spinner from '../Spinner';
var getStyledButton = function (kind) {
    switch (kind) {
        case 'primary':
            return ButtonPrimary;
        case 'secondary':
            return ButtonSecondary;
        case 'black':
            return ButtonBlack;
        case 'green':
            return ButtonGreen;
        default:
            return ButtonBase;
    }
};
var Button = forwardRef(function (props, ref) {
    var type = props.type, kind = props.kind, isLoading = props.isLoading, disabled = props.disabled, spinnerSize = props.spinnerSize, spinnerStrokeColor = props.spinnerStrokeColor, spinnerMargin = props.spinnerMargin, asTag = props.as, children = props.children;
    var t = useLocalization().t;
    var StyledButton = getStyledButton(kind);
    return (React.createElement(StyledButton, __assign({}, props, (asTag && { as: asTag }), (!type && asTag && asTag === 'button' && { type: 'button' }), (isLoading && { 'aria-label': t('h24_loading') }), (disabled && { 'aria-disabled': 'true' }), { ref: ref }), isLoading ? (React.createElement(Spinner, { margin: spinnerMargin, size: spinnerSize, strokeColor: spinnerStrokeColor })) : (children)));
});
Button.displayName = 'Button';
Button.defaultProps = {
    as: 'button',
    kind: 'primary',
    spinnerSize: SPINNER_SIZE,
    spinnerMargin: 0,
};
var ButtonLink = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), textDecoration);
ButtonLink.defaultProps = __assign(__assign({}, Button.defaultProps), { textDecoration: 'none', as: 'a' });
var ButtonWithIconWrapper = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  &:not([disabled]):active {\n    svg {\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n"], ["\n  ", ";\n  ", ";\n\n  &:not([disabled]):active {\n    svg {\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n"])), display, alignItems, themeGet('colors.brand.normal'), themeGet('colors.brand.normal'));
ButtonWithIconWrapper.defaultProps = __assign(__assign({}, Button.defaultProps), { kind: 'secondary', display: 'flex', alignItems: 'center' });
var ButtonIcon = styled(Icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  fill: ", ";\n  stroke: ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  fill: ", ";\n  stroke: ", ";\n"])), space, width, height, flexShrink, themeGet('colors.gray.10'), themeGet('colors.gray.10'));
ButtonIcon.defaultProps = {
    mr: ['sp_0', 'sp_4'],
    flexShrink: 0,
};
var ButtonWithIcon = function (_a) {
    var iconSize = _a.iconSize, iconName = _a.iconName, children = _a.children, restProps = __rest(_a, ["iconSize", "iconName", "children"]);
    return (React.createElement(ButtonWithIconWrapper, __assign({}, restProps),
        React.createElement(ButtonIcon, { name: iconName, width: iconSize, height: iconSize }),
        React.createElement("span", null, children)));
};
ButtonWithIcon.defaultProps = {
    iconSize: 28,
};
export { ButtonBase, Button, ButtonLink, ButtonWithIcon };
var templateObject_1, templateObject_2, templateObject_3;
